export const LIFE_STONE_ACTION_PERSIST = "LIFE_STONE_PERSIST";
export const LIFE_STONE_ACTION_CLEAR = "LIFE_STONE_CLEAR";
